export default "__VITE_ASSET__CZADZtKG__"